import cairo from "../../../assets/images/Governorates_logos/cairo.png";
import giza from "../../../assets/images/Governorates_logos/giza.png";
import dakahliya from "../../../assets/images/Governorates_logos/dakahliya.png";

export const governoratesLogos = [
  { text: "cairo", image: cairo },
  { text: "giza", image: giza },
  { text: "dakahliya", image: dakahliya },
];
